import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";

import { App } from "@/App";

import "./index.css";

const rootElement = document.querySelector("#app");

if (!rootElement) {
	throw new Error("Elemento #app não encontrado");
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 1, refetchOnWindowFocus: false },
		mutations: { retry: false },
	},
});

ReactDOM.createRoot(rootElement).render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>,
);
